import { useMutation } from 'react-query';

import { addEmployeeForClient } from 'api/clients/clientSmartCreation/addEmployeeForClient';

export const useCreateEmployeeForClient = () => {
  const { mutate: createEmployee, isLoading } = useMutation(addEmployeeForClient);

  return { createEmployee, isLoading };
};
